import React, { useEffect, useState } from "react";
import { DoorOpen, Users, Calendar } from "lucide-react";
import "./portal.css";

const Door = ({ title, subtitle, icon: Icon, color, glow, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    sessionStorage.setItem("visited", "true");
  }, []);

  const handleClick = () => {
    setIsOpen(true);
    setShowWelcome(true);

    setTimeout(() => {
      onClick();
    }, 1500);
  };

  return (
    <div className="door-container" onClick={handleClick}>

      <div className={`door-glow ${glow}`}></div>

      <div className="door-frame">

        <div className={`door-panel ${color} ${isOpen ? "open" : ""}`}>

          <div className="door-content">
            <Icon size={90} className="door-icon" />

            <h2>{title}</h2>
            <p>{subtitle}</p>
          </div>

          <div className="door-handle"></div>
        </div>

        {showWelcome && (
          <div className="welcome-overlay">
            <div>
              <h1 style={{ marginTop: '-20px' }}>WELCOME</h1>
              <p>{title}</p>
            </div>
          </div>
        )}

      </div>

      {!isOpen && (
        <div className="click-hint">
          CLICK TO ENTER <DoorOpen size={18} />
        </div>
      )}

    </div>
  );
};

export default function DirectoratePortal() {

  const handleFinancialClick = () => {
      window.location.href = "/";
};

const handleLeaveClick = () => {
      window.location.href = "http://leave.ubkvkvks.in/";
  };

  return (
    <div className="portal-container">

      <header className="portal-header">
        <h1>Welcome to</h1>
        <h2>Directorate of Extension Education</h2>
        <p>Select your system to continue</p>
      </header>

      <main className="portal-main">

        <Door
          title="Financial Management"
          subtitle="Budget • Accounts • Reports"
          icon={Users}
          color="financial"
          glow="glow-orange"
          onClick={handleFinancialClick}
        />

        <Door
          title="Leave Management"
          subtitle="Leave • Attendance • Approvals"
          icon={Calendar}
          color="leave"
          glow="glow-green"
          onClick={handleLeaveClick}
        />

      </main>

      <footer className="portal-footer">
        Directorate of Extension Education © {new Date().getFullYear()}
      </footer>

    </div>
  );
}